import styled from 'styled-components';
import { media, dimensions } from '../../styles/theme';

export const Main = styled.main`
  padding-top: ${dimensions.mobileHeaderHeight};
  ${media.desktop`
    padding-top: ${dimensions.headerHeight};
  `};
`;
